import { getApiService } from '@/services/api';
import { ApiResponse } from '@/services/api/types';
import { Category } from '../model/category.ts';
import { CategoryShort } from '../model/categoryShort.ts';

const CATEGORIES_PATH = '/category';

export class CategoriesApi {
  private static getApiInstance() {
    return getApiService();
  }

  static async getAll(): Promise<ApiResponse<CategoryShort[]>> {
    const apiService = this.getApiInstance();
    return await apiService.client.get<CategoryShort[]>(CATEGORIES_PATH);
  }

  static async create(data: Omit<Category, 'id'>) {
    const apiService = this.getApiInstance();
    return await apiService.client.post(CATEGORIES_PATH, data);
  }

  static async update(id: string, data: Omit<Category, 'id'>) {
    const apiService = this.getApiInstance();
    return await apiService.client.put(`${CATEGORIES_PATH}/${id}`, data);
  }

  static async delete(id: string) {
    const apiService = this.getApiInstance();
    return await apiService.client.delete(`${CATEGORIES_PATH}/${id}`);
  }
}
